"use client";

import { Icon } from "@iconify-icon/react";
import { motion } from "motion/react";

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useIsMobile } from "@/hooks/use-mobile";
import { cn } from "@/lib/utils";

interface InformationTooltipProps {
  label?: string;
  description: string;
  className?: string;
  iconSize?: string;
}

export const InformationTooltip = ({
  label,
  description,
  className,
  iconSize = "1rem",
}: InformationTooltipProps) => {
  const isMobile = useIsMobile();
  return (
    <TooltipProvider>
      {isMobile ? (
        <Popover>
          <PopoverTrigger asChild>
            <motion.button
              type="button"
              aria-label={label || description}
              className={cn("inline-flex cursor-pointer items-center gap-1.5", className)}
              whileHover={{ scale: 1.05 }}
            >
              <Icon
                className="text-muted-foreground"
                height={iconSize}
                icon="mdi:information-outline"
                width={iconSize}
              />
              {label && <span className="text-accent-foreground text-sm">{label}</span>}
            </motion.button>
          </PopoverTrigger>
          <PopoverContent align="center" className="z-[100] max-w-md text-sm" sideOffset={6} side="top">
            {description}
          </PopoverContent>
        </Popover>
      ) : (
        <Tooltip delayDuration={300}>
          <TooltipTrigger asChild>
            <motion.div
              className={cn("inline-flex cursor-help items-center gap-1.5", className)}
              whileHover={{ scale: 1.05 }}
            >
              <Icon
                className="text-muted-foreground"
                height={iconSize}
                icon="mdi:information-outline"
                width={iconSize}
              />
              {label && <span className="text-accent-foreground text-sm">{label}</span>}
            </motion.div>
          </TooltipTrigger>
          <TooltipContent align="center" className="z-[100] max-w-md text-sm" side="top">
            {description}
          </TooltipContent>
        </Tooltip>
      )}
    </TooltipProvider>
  );
};
